import { css } from '@inter-ikea-kompis/web-component';
import { ThemeFontStyleTypeEnum } from '@inter-ikea-kompis/enums';
import { FontStyle } from '@inter-ikea-kompis/themes';

import type ICountdownStyleOptions from '../../types/ICountdownStyleOptions.js';

export default class CountdownStyle {
	/**
	 * Returns styles.
	 *
	 * @param options Options.
	 * @returns Styles.
	 */
	public static getStyle(options: ICountdownStyleOptions): string {
		const { color, border } = options.theme;

		return css`
			${FontStyle.getStyle({
				type: ThemeFontStyleTypeEnum.headingSmall,
				theme: options.theme
			})}

			:host {
				display: flex;
			}

			svg {
				stroke: ${color.component.primaryPress};
				stroke-width: ${border.radius.radius4 / 16}rem;
				fill: transparent;
				height: ${57 / 16}rem;
				width: ${57 / 16}rem;
				overflow: visible;
			}

			circle {
				transition: ${options.circleAnimation ? 'all 1s linear' : '0'};
			}

			.circle--bg {
				stroke: ${color.neutral.grey200};
			}

			text {
				fill: ${color.neutral.grey900};
				stroke-width: 0;
			}
		`;
	}
}
